import styled from '@emotion/styled';

export const OperationsLoansContainer = styled.div`
  width: 100%;
  height: 100%;
`;
